export const clientColumns = [
  { header: 'Ime', key: 'firstName' },
  { header: 'Prezime', key: 'lastName' },
  { header: 'JMBG', key: 'jmbg' },
  { header: 'Broj lične karte', key: 'lk' },
  { header: 'Adresa stanovanja', key: 'address' },
  { header: 'Grad', key: 'city', registryKey: 'cities' },
  { header: 'Mobilni telefon', key: 'mobilePhone' },
  { header: 'Fiksni telefon', key: 'landlinePhone' },
  { header: 'Email', key: 'email' },
  { header: 'Spol', key: 'gender', registryKey: 'genders' },
  { header: 'Bračni status', key: 'martialStatus', registryKey: 'martialStatus' },
  { header: 'Broj članova u porodici', key: 'householdSize' },
];

export const applicationColumns = [
  { header: 'Broj zahtjeva', key: 'erpKey' },
  { header: 'Zahtjev broj', key: 'erpKeyAlt' },
  { header: 'Status', key: 'status' },
  { header: 'Radnik', key: 'employee' },
  ...clientColumns,
  { header: 'Iznos', key: 'amount' },
  { header: 'Predloženi iznos', key: 'recommendedAmount' },
  { header: 'Broj rata', key: 'repaymentPeriod' },
  { header: 'Predloženi kreditni proizvod', key: 'recommendedLoanProduct', registryKey: 'loanProducts' },
  { header: 'Grace period', key: 'gracePeriod' },
  { header: 'Kancelarija', key: 'office', registryKey: 'offices' },
  { header: 'Namjena', key: 'loanPurpose', registryKey: 'loanPurposes' },
  { header: 'Namjena korištenja', key: 'loanProduct', registryKey: 'loanPurposes' },
  { header: 'Djelatnost kredita', key: 'recommendedLoanPurpose', registryKey: 'loanPurposeActivities' },
  { header: 'Tip kredita', key: 'loanType', registryKey: 'loanType' },
  { header: 'Vrsta isplate', key: 'payoutType', registryKey: 'payoutType' },
  { header: 'Napomena', key: 'remark' },
  { header: 'Mjesečni prihodi', key: 'monthlyIncome' },
  { header: 'Nedokazivi mjesečni prihodi', key: 'additionalIncome' },
  { header: 'Mjesečna primanja domaćinstva', key: 'monthlyHouseholdIncome' },
  { header: 'Mjesečni troškovi domaćinstva', key: 'monthlyHouseholdExpenses' },
  { header: 'Postojeća kreditna zaduženja', key: 'householdExistingLoanAmount' },
  { header: 'Klijent ima postojeće kredite?', key: 'clientHasExistingLoan', type: 'boolean' },
  { header: 'Domaćinstvo ima postojeće kredite?', key: 'householdHasExistingLoan', type: 'boolean' },
  { header: 'Kašenjenje u otplati postojećih obaveza?', key: 'existingLoanDelinquency', type: 'boolean' },
  { header: 'Tip aktivacije', key: 'activationType', registryKey: 'activationTypes' },
  { header: 'Prenošen', key: 'transmittedAt' },
  { header: 'Kreiran', key: 'createdAt' },
  { header: 'Zadnji put ažuriran', key: 'updatedAt' },
  { header: 'Rekreiran', key: 'reactedAt' },
  { header: 'Razlog odbijanja', key: 'abandonmentReason' },
  { header: 'Opis odbijanja', key: 'abandonmentDescription' },
  { header: 'Razlog proslijeđivanja', key: 'forwardRemark' },
];
